"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cacheActions = require("./cacheActions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cacheReducer = function cacheReducer(state, action) {
  switch (action.type) {
    case _cacheActions.EDIT_PAGE:
      {
        var newTemp = _objectSpread({}, state.temp);

        newTemp[action.awyesId] = {
          awyesId: action.awyesId,
          id: action.id,
          typeName: action.typeName
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          temp: newTemp,
          page: {
            awyesId: action.awyesId,
            route: action.route
          }
        });
      }

    case _cacheActions.UPDATE:
      {
        var _action$updates, _state$page;

        var awyesIds = Object.keys((_action$updates = action.updates) !== null && _action$updates !== void 0 ? _action$updates : {});
        if (!awyesIds.length) return state;

        var newCache = _objectSpread({}, state.cache);

        var _newTemp = _objectSpread({}, state.temp);

        awyesIds.forEach(function (awyesId) {
          newCache[awyesId] = action.updates[awyesId];
          delete _newTemp[awyesId];
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          cache: newCache,
          temp: _newTemp,
          page: action.fromUpdate && action.awyesId === ((_state$page = state.page) === null || _state$page === void 0 ? void 0 : _state$page.awyesId) ? undefined : state.page
        });
      }

    case _cacheActions.TEMPORARY:
      {
        var _state$cache$action$a, _state$cache, _state$temp$action$aw, _state$temp, _objectSpread2;

        var temp = _objectSpread(_objectSpread(_objectSpread({}, (_state$cache$action$a = (_state$cache = state.cache) === null || _state$cache === void 0 ? void 0 : _state$cache[action.awyesId]) !== null && _state$cache$action$a !== void 0 ? _state$cache$action$a : {}), (_state$temp$action$aw = (_state$temp = state.temp) === null || _state$temp === void 0 ? void 0 : _state$temp[action.awyesId]) !== null && _state$temp$action$aw !== void 0 ? _state$temp$action$aw : {}), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, action.field, action.value), _defineProperty(_objectSpread2, "awyesId", action.awyesId), _objectSpread2));

        return _objectSpread(_objectSpread({}, state), {}, {
          temp: _objectSpread(_objectSpread({}, state.temp), {}, _defineProperty({}, action.awyesId, temp))
        });
      }

    case _cacheActions.REMOVE_TEMPORARY:
      {
        var _state$page2;

        var _newTemp2 = _objectSpread({}, state.temp);

        delete _newTemp2[action.awyesId];
        return _objectSpread(_objectSpread({}, state), {}, {
          temp: _newTemp2,
          page: action.awyesId === ((_state$page2 = state.page) === null || _state$page2 === void 0 ? void 0 : _state$page2.awyesId) ? undefined : state.page
        });
      }

    case _cacheActions.REMOVE:
      {
        var _state$page3;

        var _newCache = _objectSpread({}, state.cache);

        delete _newCache[action.awyesId];

        var _newTemp3 = _objectSpread({}, state.temp);

        delete _newTemp3[action.awyesId];
        return _objectSpread(_objectSpread({}, state), {}, {
          cache: _newCache,
          temp: _newTemp3,
          page: action.awyesId === ((_state$page3 = state.page) === null || _state$page3 === void 0 ? void 0 : _state$page3.awyesId) ? undefined : state.page
        });
      }

    default:
      throw new Error("Unsupported action type: ".concat(action.type));
  }
};

var _default = cacheReducer;
exports["default"] = _default;